import { z } from "zod";

// ==================
// Profile Picture Media Schema
// ==================

/** Media object attached to the client profile */
export const ClientProfileMediaSchema = z.object({
    id: z.string(),
    cdn_url: z.string(),
    mime_type: z.string(),
    size: z.number(),
});

export type ClientProfileMedia = z.infer<typeof ClientProfileMediaSchema>;

// ==================
// User Schema (Profile context)
// ==================

/** User data returned in profile responses */
export const ClientProfileUserSchema = z.object({
    id: z.number().int().positive(),
    email: z.email(),
    email_verified_at: z.string().nullable(),
    first_name: z.string(),
    last_name: z.string(),
});

export type ClientProfileUser = z.infer<typeof ClientProfileUserSchema>;

// ==================
// Client Data Schema
// ==================

/** Client-specific data returned in profile responses */
export const ClientProfileDataSchema = z.object({
    id: z.number().int().positive(),
    company_name: z.string().nullable(),
    company_website: z.string().nullable(),
    profile_picture: z.string().nullable(),
    profile_picture_media: ClientProfileMediaSchema.nullable(),
});

export type ClientProfileData = z.infer<typeof ClientProfileDataSchema>;

// ==================
// Pending Email Change Schema
// ==================

/** Pending email change information */
export const PendingEmailChangeSchema = z.object({
    new_email: z.email(),
    requested_at: z.string(),
    expires_at: z.string(),
});

export type PendingEmailChange = z.infer<typeof PendingEmailChangeSchema>;

// ==================
// Full Client Profile Schema
// ==================

/** Complete client profile including user, client data, and pending email change */
export const ClientProfileSchema = z.object({
    user: ClientProfileUserSchema,
    client: ClientProfileDataSchema,
    pending_email_change: PendingEmailChangeSchema.nullable(),
});

export type ClientProfile = z.infer<typeof ClientProfileSchema>;

